// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1TIoM","title":"InfoRow_title__9TLTk"};